function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 1.4C2 .63 2.63 0 3.4 0H13c.77 0 1.4.63 1.4 1.4v2a.6.6 0 11-1.2 0v-2a.2.2 0 00-.2-.2H3.4a.2.2 0 00-.2.2v.4a.6.6 0 01-1.2 0v-.4zM0 4.2c0-.77.63-1.4 1.4-1.4h3.22c.42 0 .82.2 1.09.53l1.12 1.4c.04.04.1.07.15.07h7.62c.77 0 1.4.63 1.4 1.4v5.6c0 .77-.63 1.4-1.4 1.4H1.4A1.4 1.4 0 010 11.8V4.2zM1.4 4a.2.2 0 00-.2.2V8h13.6V6.2a.2.2 0 00-.2-.2H6.98c-.42 0-.82-.2-1.09-.53l-1.12-1.4A.2.2 0 004.62 4H1.4zm13.4 5.2H1.2v2.6c0 .11.09.2.2.2h13.2a.2.2 0 00.2-.2V9.2z",
  clipRule: "evenodd"
});

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none",
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.50a3e139.svg";
export { ForwardRef as ReactComponent };